/**
 * @generated SignedSource<<9e55adb9d073236c21f2984413ddb38c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditForm_form$data = {
  readonly id: string;
  readonly isClosed: boolean;
  readonly questions: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EditQuestionCard_formQuestion">;
  }>;
  readonly " $fragmentType": "EditForm_form";
};
export type EditForm_form$key = {
  readonly " $data"?: EditForm_form$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditForm_form">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditForm_form",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClosed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormQuestion",
      "kind": "LinkedField",
      "name": "questions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditQuestionCard_formQuestion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Form",
  "abstractKey": null
};
})();

(node as any).hash = "7f843d11dae33ccdfaf4709f5239af7b";

export default node;
